import {
  LanguageData,
  LocalizedStringRecord,
} from "../app/slices/TrainingLocalizationSlice";

/**
 * Pure function that checks if there are missing translations across both
 * regular localized entries and Prop localized entries.
 *
 * A translation is "missing" when the reference language has a non-empty
 * trimmed value for a key and at least one other includeInPublish language
 * has an empty or whitespace-only value for that key.
 */
export function checkMissingTranslations(
  localizedEntries: LocalizedStringRecord,
  propLocalizedEntries: LocalizedStringRecord,
  localizedLanguages: LanguageData[],
  refLang: string
): boolean {
  const allLanguages = localizedLanguages.filter(
    (l) => l.includeInPublish ?? true
  );
  const nonRefLanguages = allLanguages.filter(
    (lang) => lang.shortcode !== refLang
  );

  // If there's only the reference language, no missing translations
  if (nonRefLanguages.length === 0) {
    return false;
  }

  // Check regular localized entries
  const allKeys = Object.keys(localizedEntries);
  for (const key of allKeys) {
    const keyData = localizedEntries[key];
    if (!keyData) continue;

    const refValue = keyData[refLang]?.value;
    const hasRefValue = refValue && refValue.trim() !== "";
    if (!hasRefValue) continue;

    for (const lang of nonRefLanguages) {
      const langValue = keyData[lang.shortcode]?.value;
      const hasLangValue = langValue && langValue.trim() !== "";
      if (!hasLangValue) {
        return true;
      }
    }
  }

  // Check Prop localized entries for missing translations
  for (const key in propLocalizedEntries) {
    const keyData = propLocalizedEntries[key];
    if (!keyData) continue;

    const refValue = keyData[refLang]?.value;
    const hasRefValue = refValue && refValue.trim() !== "";
    if (!hasRefValue) continue;

    for (const lang of nonRefLanguages) {
      const langValue = keyData[lang.shortcode]?.value;
      const hasLangValue = langValue && langValue.trim() !== "";
      if (!hasLangValue) {
        return true;
      }
    }
  }

  return false;
}
